<template>
  <div>
    <h1>WELCOME TO PLAYFLOW</h1>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
